import {BankAccountDomain} from '@dms/api/base';
import {useIsLicenceEnabled} from '@dms/shared';

import {getBankAccountDomainLabel} from '../utils/getBankAccountDomainLabel';
import {getLicensedBankAccountDomains} from '../utils/getLicensedBankAccountDomains';

export interface BankAccountDomainOption {
  label: string;
  value: BankAccountDomain;
}

interface UseBankAccountDomainOptionsResult {
  domainOptions: BankAccountDomainOption[];
  // Assigning a domain only changes behaviour when a tenant operates in more than
  // one domain, so the assignment UI is shown only when at least two are licensed.
  isDomainAssignmentEnabled: boolean;
}

export function useBankAccountDomainOptions(): UseBankAccountDomainOptionsResult {
  const {isSalesModuleEnabled, isWorkshopModuleEnabled} = useIsLicenceEnabled();

  const licensedDomains = getLicensedBankAccountDomains(
    isSalesModuleEnabled,
    isWorkshopModuleEnabled
  );

  const domainOptions = licensedDomains.map((value) => ({
    label: getBankAccountDomainLabel(value),
    value,
  }));

  return {
    domainOptions,
    isDomainAssignmentEnabled: licensedDomains.length >= 2,
  };
}
